var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgThumbsDown = function SvgThumbsDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7551,20.99971h4.90148a8.69392,8.69392,0,0,0-1.54047,4.5207c0,2.24071.56017,3.92124,2.52076,4.34137,1.82055.42013,2.52076-.14,2.94089-1.40044.56017-1.40044.56017-3.081,1.12034-4.06128a10.9479,10.9479,0,0,1,3.92118-4.48141C20.373,19.44783,22,19.6914,22,17.818V6.61446a1.42549,1.42549,0,0,0-.98029-1.26039,18.61593,18.61593,0,0,1-4.90148-1.40044,9.49184,9.49184,0,0,0-4.6214-.84027c-2.49531,0-4.62139.28009-5.74173,1.40044a4.184,4.184,0,0,0-.84025,3.221,3.3248,3.3248,0,0,0-.9803,3.64114,4.03924,4.03924,0,0,0-.56017,3.78119C1.27375,17.67794,2.81421,20.99971,5.7551,20.99971Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24,18.99971h5a1,1,0,0,0,1-1v-12a1,1,0,0,0-1-1H24a1,1,0,0,0-1,1v12A1,1,0,0,0,24,18.99971Zm3.5-5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,27.5,13.99971Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThumbsDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thumbsDown.c6be056c.svg";
export { ForwardRef as ReactComponent };